<template lang="pug">
  modal(name="lockerHistory", :minWidth="900", :minHeight="500", :maxHeight="700", @opened="opened",
    :scrollable="true", :adaptive="true", @close="onClose")

    .modal-locker-history-wrapper
      .close
        a.glyphicon.glyphicon-remove.a-without-decoration(style="left: 20px; position: relative;", @click="close")

      h3 Histórico de operações - {{ date }}
      h4 {{ employee.name }}

      div
        .locker-history-table-row
          h4 Data
          h4 Quem fez a ação
          h4 Tipo
          h4 Observações

        template(v-if="operations.length")
          .locker-history-table-row(v-for="op in operations")
            span
              label {{ op.date | date }}
              br
              label {{ op.date | hourMin }}
            label {{ op.user }}
            label {{ op.title }}
            label {{ op.observation }}

        template(v-else="")
          .locker-history-table-row(v-for="i in [0, 1, 2, 3]")
            label ...
            label ...
            label ...
            label ...

</template>

<script>
import moment from 'moment'

export default {
  data () {
    return {
      operations: []
    }
  },
  computed: {
    date () {
      return moment(this.$store.state.timesheet.header.endDate).format('MMMM [de] YYYY')
    },
    employee () {
      return this.$store.state.sheet.lines[0].employee
    }
  },
  methods: {
    close () {
      this.$modal.hide('lockerHistory')
    },
    onClose () {
      this.operations = []
    },
    async opened () {
      const endDate = this.$store.state.timesheet.header.endDate

      const params = {
        month: endDate.getMonth() + 1,
        year: endDate.getFullYear()
      }
      const data = {
        employees: [this.employee.id]
      }
      const result = await this.$API.twoWayLockerGetData.save(params, data)
      this.operations = result.data.success[0].operations
    }
  },
  filters: {
    date (date) {
      return moment(date).format('DD/MM/YYYY')
    },
    hourMin (date) {
      return moment(date).format('HH:mm')
    }
  }
}
</script>

<style scoped>
.modal-locker-history-wrapper {
  text-align: center;
  padding: 0 5% 5% 5%;
  overflow: scroll;
  height: 100%;
}

.locker-history-table-row {
  display: grid;
  grid-column-gap: 10px;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: auto auto;
  border-bottom: 0.5px lightgray solid;
  align-items: center;
}
.locker-history-table-row > hr {
  grid-row-start: row2-start;
  grid-row-end: row2-end;
  grid-column-start: 1;
  grid-column-end: 5;
}
.close {
  margin-top: 10px;
  position: absolute;
  right: 40px;
}
</style>
